import React, { useEffect, useMemo, useState } from 'react';


import { ProgressBar } from '../../../Components/CustomComponent';
import { useAppContext } from '../../../Context/AppContext';
import { useSocket } from '../../../Context/SocketContext';
import { OPTIONS_TYPES } from '../../../constants';



export default function AudienceSupport({ quiz_id, question_id, options = [] }) {
    const { isSocketConnected } = useAppContext();
    const socket = useSocket()

    const [answers, setAnswers] = useState(() => {
        return options.map(item => ({ option: item.option, option_type: item.option_type, image_url: item.image_url, count: 0 }))
    })


    useEffect(() => {
        if (isSocketConnected) {
            socket.on('audiencePollQuestionCount_', (data) => {
                setAnswers(data?.question_options?.map(item => ({ option: item.option, option_type: item.option_type, image_url: item.image_url, count: item.percentage || 0 })))
            })

            socket.emit('_getQuestionPoll', {
                quiz_id: quiz_id,
                question_id: question_id,
            });
        }
        return () => {
            socket.dispose('audiencePollQuestionCount_')
        }
    }, [isSocketConnected])



    return (
        answers?.map((item, ind) => {
            return <ProgressBar
                text={
                    item?.option_type === OPTIONS_TYPES.TEXT ?
                        item.option :
                        <img src={item.image_url} alt={'Option Image ' + ind} />
                }
                classes='fw-bold'
                percentage={item.count}
            />
        })
    )
}
